import { ChainData, ChainType } from "@0xsquid/squid-types";
import { useMemo } from "react";
import { Token } from "../../core";
import { findNativeToken } from "../../services";
import { useSquidTokens } from "./useSquidTokens";

export function useNativeTokenForChain(chain?: ChainData) {
  const {
    evmTokens,
    cosmosTokens,
    solanaTokens,
    bitcoinTokens,
    suiTokens,
    xrplTokens,
    stellarTokens,
    cantonTokens,
  } = useSquidTokens();

  const getTokensForChainType = (): Token[] => {
    if (!chain?.chainType) return [];

    switch (chain.chainType) {
      case ChainType.EVM:
        return evmTokens;
      case ChainType.COSMOS:
        return cosmosTokens;
      case ChainType.SOLANA:
        return solanaTokens;
      case ChainType.BTC:
        return bitcoinTokens;
      case ChainType.SUI:
        return suiTokens;
      case ChainType.XRPL:
        return xrplTokens;
      case ChainType.STELLAR:
        return stellarTokens;
      case ChainType.CANTON:
        return cantonTokens;
    }
  };

  const nativeTokenForChainType = useMemo(() => {
    if (!chain) return undefined;
    return findNativeToken(getTokensForChainType(), chain);
  }, [chain]);

  return { nativeToken: nativeTokenForChainType };
}
